import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { deleteKeys } from "lib/transforms"
import { CustomerDetail, CustomerDetailTabEnum } from "modules/customers/components/Detail"
import { CustomerSearchSchema } from "schema"
import { CustomerListSearchSchema } from "./route"

// eslint-disable-next-line react-refresh/only-export-components
export const SearchSchema = CustomerListSearchSchema.merge(CustomerSearchSchema)

export const Route = createFileRoute("/_base/_auth/customers/list/$id")({
  component: RouteComponent,
  validateSearch: (data) => {
    return SearchSchema.parse(data)
  },
})

function RouteComponent() {
  const { id } = Route.useParams()
  const search = Route.useSearch()
  const params = Route.useParams()
  const navigate = useNavigate()

  function onClose() {
    navigate({
      to: "/customers/list",
      search: deleteKeys(["lastRow"], search),
    })
  }

  function onTabChange(tab: CustomerDetailTabEnum) {
    navigate({
      to: Route.fullPath,
      params,
      search: { ...search, tab },
    })
  }
  function onConversationClick(conversationId?: string) {
    navigate({
      to: Route.fullPath,
      params,
      search:
        conversationId === undefined
          ? { ...deleteKeys(["conversationId"], search), tab: "conversations" }
          : { ...search, tab: "conversations", conversationId },
    })
  }

  function onArchivedCustomerRedirect(originalCustomerId: string) {
    navigate({
      to: Route.fullPath,
      params: { ...params, id: originalCustomerId },
      search,
      replace: true,
    })
  }

  return (
    <CustomerDetail
      customerId={id}
      conversationId={search.conversationId?.toString()}
      onClose={onClose}
      currentTab={search.tab}
      onTabChange={onTabChange}
      onConversationClick={onConversationClick}
      issueId={search.issueId}
      onIssueClick={(issueId, tab) => {
        navigate({
          to: Route.fullPath,
          params,
          search: { ...search, tab, issueId },
        })
      }}
      onArchivedCustomerRedirect={onArchivedCustomerRedirect}
    />
  )
}
